
import { useEffect } from "react";
import { storeCampaignCookie } from "./referralUtils";

export const useOkxCampaign = () => {
  useEffect(() => {
    // This will run once when the component mounts
    storeCampaignCookie("okx", 42); // 42 days (6 weeks) expiration
    
    // Set a specific language preference key for OKX
    // This helps avoid conflicts with other landing pages
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    
    if (langParam) {
      localStorage.setItem('okx_prefLang', langParam);
    }
    
    // Log for debugging
    console.log("OKX campaign cookie set with 6 weeks expiration");
    
    // Add debug log for language
    const currentLang = localStorage.getItem('okx_prefLang') || 'en';
    console.log(`Current OKX language setting: ${currentLang}`);
  }, []);
};
